var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-contact container"},[_c('div',{staticClass:"centered"},[_c('h3',[_vm._v(_vm._s(_vm.t('The site is down due to unusual traffic. Please try again in a few minutes')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }